import { getConfig } from '../common/helpers/config';

export const { showDebugMenu, showDebugProjectView } = getConfig().app;
